import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.visit-medical-documents.procedures': {
         selector: {
            selectorPlaceholder: 'Uzupełnij kod ICD-9 lub nazwę procedury...',
         },
      },
   },
};

const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.shared.visit-medical-documents.procedures'
);

export const procedureSelectorTranslationKeys = translationKeys.selector;
